import { render, staticRenderFns } from "./TreeRelaciones.vue?vue&type=template&id=48e6ff78&scoped=true"
import script from "./TreeRelaciones.vue?vue&type=script&lang=js"
export * from "./TreeRelaciones.vue?vue&type=script&lang=js"
import style0 from "./TreeRelaciones.vue?vue&type=style&index=0&id=48e6ff78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e6ff78",
  null
  
)

export default component.exports